var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
var initialStore = {
    locations: [],
    setLocations: function (locations) { },
};
export var StateContext = React.createContext(initialStore);
StateContext.displayName = "FormStateContext";
function storeReducer(store, action) {
    switch (action.type) {
        case "SET_LOCATIONS": {
            return __assign(__assign({}, store), { locations: action.locations });
        }
    }
}
export var FormStateProvider = function (props) {
    var _a = React.useReducer(storeReducer, initialStore), state = _a[0], dispatch = _a[1];
    var setLocations = function (locations) {
        return dispatch({
            type: "SET_LOCATIONS",
            locations: locations,
        });
    };
    var value = useMemo(function () { return (__assign(__assign({}, state), { setLocations: setLocations })); }, [state]);
    return _jsx(StateContext.Provider, __assign({ value: value }, props), void 0);
};
export var useFormState = function () {
    var context = React.useContext(StateContext);
    if (context === undefined) {
        throw new Error("useFormState must be used within a StateProvider");
    }
    return context;
};
